const NoRecordMessage = ({title, message}) => {
  return <div>No record found</div>;
};

export default NoRecordMessage;
